import { CalendarDaysIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { NavLink } from 'libs/router'
import { format } from 'libs/dates'
import { Panel, PanelEmpty } from 'shared/components'
import { Spinner } from 'shared/atoms'
import { routes } from 'config/routes'
import { useFetchBookings } from 'features/bookings/pages/index/queries/useFetchBookings'
import { MAX_PANEL_ITEMS, viewAllClassName } from '../panel'

type UserBookingsProps = {
	userId: string
}

const date = (value: string) => format(new Date(value), 'dd.MM.yyyy')

export const UserBookings = ({ userId }: UserBookingsProps) => {
	const { t } = useTranslation()
	const { bookings, isBookingsLoading } = useFetchBookings(`user_id=${userId}`)
	const results = bookings?.data?.results ?? []

	const renderContent = () => {
		if (isBookingsLoading && !results.length) return <Spinner />
		if (!results.length) return <PanelEmpty>{t('No bookings yet')}</PanelEmpty>

		return (
			<ul className="divide-y divide-border">
				{results.slice(0, MAX_PANEL_ITEMS).map((booking) => (
					<li key={booking.id} className="flex items-center justify-between gap-3 py-2 text-[12px]">
						<NavLink
							className="rounded bg-primary-soft px-1.5 py-0.5 font-semibold tabular-nums text-primary hover:underline"
							to={routes.bookingEdit(String(booking.id))}>
							#{booking.ref_nr}
						</NavLink>
						<span className="tabular-nums text-muted-foreground">
							{date(booking.start_date)} – {date(booking.end_date)}
						</span>
					</li>
				))}
			</ul>
		)
	}

	return (
		<Panel
			title={t('Bookings')}
			icon={<CalendarDaysIcon />}
			action={
				results.length > 0 && (
					<NavLink className={viewAllClassName} to={`${routes.bookingIndex}?user_id=${userId}`}>
						{t('View all')}
					</NavLink>
				)
			}>
			{renderContent()}
		</Panel>
	)
}
